import useGet from "../../../hooks/useGet"
import Table from "../../../components/table"
import columns from "./column";
import useTable from "../../../hooks/useTable"
import CardContainer from "../../../components/card_container"
import { ADDADMINISTRATOR, DETAILADMINISTRATOR, EDITADMINISTRATOR } from "../../../routes/routes_name";
import useDelete from "../../../hooks/useDelete";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";

const AdministratorPage = () => {
    const {
        filter,
        isLoading,
        data,
        error,
        totalPages,
        handlePagination,
        handleLimit,
        handleFilter,
    } = useGet('/v1/user/superadmin')

    const {
        isLoading: isLoadingPost,
        dataRemove,
        handleEdit,
        handleSelected,
    } = useTable();

    const navigate = useNavigate();

    const {
        isLoading: isLoadingDelete,
        handleDelete
    } = useDelete();

    const handleConfirmDelete = () => {
        if (dataRemove.length > 0) {
            swal({
                title: "Are you sure?",
                text: "Once deleted, you will not be able to recover this administrator data!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    const params = {
                        url: `/v1/user/junk-superadmin?_id=${dataRemove[0]._id}`,
                        titleSuccess: 'Deleted!',
                        descSuccess: 'Administrator data has been successfully deleted.',
                    };
                    handleDelete(params).then(() => {
                        window.location.reload();
                    });
                }
            });
        }
    };

    const handleDetail = () => {
        if (dataRemove.length !== 1) {
            return;
        }

        const selected = dataRemove[0];
        const selectedId = selected?._id || selected?.id;

        if (selectedId) {
            navigate(DETAILADMINISTRATOR.replace(":id", selectedId));
        }
    };

    return (
        <>
            <CardContainer
                title="List of Administrator"
                isHeader={true}
                addShow={true}
                addClick={ADDADMINISTRATOR}
                deleteShow={dataRemove.length > 0}
                deleteClick={handleConfirmDelete}
                editShow={dataRemove.length === 1}
                detailShow={dataRemove.length === 1}
                detailClick={handleDetail}
                editClick={() => handleEdit(EDITADMINISTRATOR)}
                onSearchChange={handleFilter}
                searchPlaceholder="Search name or email">
                <div className="expanded-y">
                    <div className="table-content">
                        <Table
                            filter={filter}
                            isLoading={isLoading}
                            error={error}
                            data={data}
                            totalPages={totalPages}
                            handlePagination={handlePagination}
                            handleLimit={() => { }}
                            handleChangeSelect={handleSelected}
                            columns={columns} />
                    </div>
                </div>
            </CardContainer>
        </>
    )
}

export default AdministratorPage;
